import { useState } from 'react';
import Layout from '../../components/feature/Layout';
import { eventLogs, eventTypes, type EventLog } from '../../mocks/events';

const campaignNames = ['Tümü', 'Botoks & Dolgu Paketi', 'Lazer Epilasyon 6 Seans', 'İpek Kirpik Komple', 'Dermapen Cilt Yenileme', 'Saç Mezoterapisi 4 Seans', 'Komple SPA Günü'];
const sources = ['Tümü', 'google', 'instagram', 'facebook', 'organic', 'tiktok', 'youtube', 'direct'];
const devices = ['Tümü', 'mobile', 'desktop', 'tablet'];

function EventTypeBadge({ type }: { type: string }) {
  const et = eventTypes.find(e => e.value === type);
  if (!et) return null;
  return (
    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-medium whitespace-nowrap" style={{ backgroundColor: `${et.color}18`, color: et.color }}>
      <i className={`${et.icon} text-[11px]`} />
      {et.label}
    </span>
  );
}

function EventDetailModal({ event, onClose }: { event: EventLog; onClose: () => void }) {
  return (
    <div className="fixed inset-0 bg-black/30 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-modal w-full max-w-lg" onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between px-6 py-4 border-b border-border">
          <div>
            <h3 className="text-[16px] font-semibold text-charcoal-600">Event Detayı</h3>
            <p className="text-[12px] text-charcoal-300 mt-0.5">{event.time}</p>
          </div>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-charcoal-50 cursor-pointer">
            <i className="ri-close-line text-charcoal-400" />
          </button>
        </div>
        <div className="p-6 space-y-4">
          <div className="flex items-center gap-3">
            <EventTypeBadge type={event.eventName} />
          </div>
          <div className="grid grid-cols-2 gap-3">
            {[
              { label: 'Ziyaretçi Token', value: event.visitorToken },
              { label: 'Kampanya', value: event.campaign || '—' },
              { label: 'Kaynak', value: `${event.source}/${event.medium || 'direct'}` },
              { label: 'Cihaz', value: event.device },
              { label: 'Tarayıcı', value: event.browser },
              { label: 'Şehir', value: event.city },
            ].map(item => (
              <div key={item.label} className="bg-[#FAF8F4] rounded-xl p-3">
                <p className="text-[11px] text-charcoal-300 mb-0.5">{item.label}</p>
                <p className="text-[13px] font-medium text-charcoal-600 truncate">{item.value}</p>
              </div>
            ))}
          </div>
          <div>
            <p className="text-[12px] font-medium text-charcoal-400 mb-2">URL</p>
            <div className="bg-[#FAF8F4] rounded-xl p-3">
              <p className="text-[12px] text-charcoal-500 font-mono break-all">{event.url}</p>
            </div>
          </div>
          {Object.keys(event.extraData).length > 0 && (
            <div>
              <p className="text-[12px] font-medium text-charcoal-400 mb-2">Ek Veriler</p>
              <div className="bg-[#FAF8F4] rounded-xl p-3 space-y-2">
                {Object.entries(event.extraData).map(([k, v]) => (
                  <div key={k} className="flex items-center justify-between text-[12px]">
                    <span className="text-charcoal-300 font-mono">{k}</span>
                    <span className="text-charcoal-500 font-medium">{v}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default function EventLogs() {
  const [selectedType, setSelectedType] = useState('all');
  const [selectedCampaign, setSelectedCampaign] = useState('Tümü');
  const [selectedSource, setSelectedSource] = useState('Tümü');
  const [selectedDevice, setSelectedDevice] = useState('Tümü');
  const [searchToken, setSearchToken] = useState('');
  const [selectedEvent, setSelectedEvent] = useState<EventLog | null>(null);

  const filtered = eventLogs.filter(e => {
    if (selectedType !== 'all' && e.eventType !== selectedType) return false;
    if (selectedCampaign !== 'Tümü' && e.campaign !== selectedCampaign) return false;
    if (selectedSource !== 'Tümü' && e.source !== selectedSource) return false;
    if (selectedDevice !== 'Tümü' && e.device !== selectedDevice) return false;
    if (searchToken && !e.visitorToken.toLowerCase().includes(searchToken.toLowerCase())) return false;
    return true;
  });

  return (
    <Layout>
      <div className="space-y-5">
        {/* Filters */}
        <div className="bg-white rounded-2xl shadow-card p-5">
          <div className="flex flex-wrap gap-3 items-center">
            <div className="relative flex-1 min-w-[200px]">
              <div className="w-4 h-4 flex items-center justify-center absolute left-3 top-1/2 -translate-y-1/2">
                <i className="ri-search-line text-charcoal-300 text-[14px]" />
              </div>
              <input value={searchToken} onChange={e => setSearchToken(e.target.value)} placeholder="Ziyaretçi token ara..." className="w-full h-[38px] pl-9 pr-4 bg-[#FAF8F4] border border-border rounded-xl text-[13px] placeholder-charcoal-300 focus:outline-none focus:border-champagne-400" />
            </div>
            <select value={selectedType} onChange={e => setSelectedType(e.target.value)} className="h-[38px] px-3 bg-[#FAF8F4] border border-border rounded-xl text-[13px] text-charcoal-500 focus:outline-none focus:border-champagne-400 cursor-pointer">
              <option value="all">Tüm Eventler</option>
              {eventTypes.map(et => <option key={et.value} value={et.value}>{et.label}</option>)}
            </select>
            <select value={selectedCampaign} onChange={e => setSelectedCampaign(e.target.value)} className="h-[38px] px-3 bg-[#FAF8F4] border border-border rounded-xl text-[13px] text-charcoal-500 focus:outline-none focus:border-champagne-400 cursor-pointer">
              {campaignNames.map(c => <option key={c}>{c}</option>)}
            </select>
            <select value={selectedSource} onChange={e => setSelectedSource(e.target.value)} className="h-[38px] px-3 bg-[#FAF8F4] border border-border rounded-xl text-[13px] text-charcoal-500 focus:outline-none focus:border-champagne-400 cursor-pointer">
              {sources.map(s => <option key={s}>{s}</option>)}
            </select>
            <select value={selectedDevice} onChange={e => setSelectedDevice(e.target.value)} className="h-[38px] px-3 bg-[#FAF8F4] border border-border rounded-xl text-[13px] text-charcoal-500 focus:outline-none focus:border-champagne-400 cursor-pointer">
              {devices.map(d => <option key={d}>{d}</option>)}
            </select>
            <button className="h-[38px] px-4 bg-[#FAF8F4] border border-border rounded-xl text-[13px] text-charcoal-400 hover:border-champagne-400 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2">
              <div className="w-4 h-4 flex items-center justify-center"><i className="ri-calendar-line text-champagne-500 text-[14px]" /></div>
              Tarih Filtrele
            </button>
          </div>
        </div>

        {/* Table */}
        <div className="bg-white rounded-2xl shadow-card overflow-hidden">
          <div className="px-6 py-4 border-b border-border flex items-center justify-between">
            <div>
              <h3 className="text-[15px] font-semibold text-charcoal-600">Event Kayıtları</h3>
              <p className="text-[12px] text-charcoal-300 mt-0.5">{filtered.length} kayıt bulundu</p>
            </div>
            <button className="flex items-center gap-2 h-[34px] px-4 bg-champagne-500 text-white rounded-xl text-[12px] font-medium hover:bg-champagne-600 transition-colors cursor-pointer whitespace-nowrap">
              <div className="w-4 h-4 flex items-center justify-center"><i className="ri-download-line text-[13px]" /></div>
              Dışa Aktar
            </button>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-[#FAF8F4] border-b border-border">
                  {['Zaman', 'Event Tipi', 'Ziyaretçi', 'Kampanya', 'Kaynak', 'Cihaz', 'Buton', 'Şehir', ''].map(h => (
                    <th key={h} className="px-4 py-3 text-left text-[11px] font-semibold text-charcoal-300 uppercase tracking-wide whitespace-nowrap">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map((event, idx) => (
                  <tr key={event.id} className={`border-b border-border hover:bg-[#FAF8F4] transition-colors ${idx % 2 === 0 ? '' : 'bg-[#FDFCFA]'}`}>
                    <td className="px-4 py-3 text-[12px] text-charcoal-400 whitespace-nowrap font-mono">{event.time.split(' ').slice(-1)[0]}</td>
                    <td className="px-4 py-3"><EventTypeBadge type={event.eventName} /></td>
                    <td className="px-4 py-3 text-[12px] font-medium text-charcoal-500 whitespace-nowrap">
                      <span className="inline-flex items-center gap-1.5 px-2 py-0.5 bg-charcoal-50 rounded-lg font-mono text-[11px]">{event.visitorToken}</span>
                    </td>
                    <td className="px-4 py-3 text-[12px] text-charcoal-500 max-w-[180px] truncate">{event.campaign || '—'}</td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      <span className="inline-flex items-center gap-1 text-[12px] text-charcoal-400">
                        <span className="font-medium text-charcoal-500">{event.source}</span>
                        {event.medium && <span className="text-charcoal-300">/{event.medium}</span>}
                      </span>
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      <span className="inline-flex items-center gap-1 text-[12px]">
                        <i className={`${event.device === 'mobile' ? 'ri-smartphone-line' : event.device === 'tablet' ? 'ri-tablet-line' : 'ri-computer-line'} text-charcoal-300 text-[13px]`} />
                        <span className="text-charcoal-400 capitalize">{event.device}</span>
                      </span>
                    </td>
                    <td className="px-4 py-3 text-[12px] text-charcoal-400 max-w-[140px] truncate">{event.button || '—'}</td>
                    <td className="px-4 py-3 text-[12px] text-charcoal-400">{event.city}</td>
                    <td className="px-4 py-3">
                      <button onClick={() => setSelectedEvent(event)} className="w-7 h-7 flex items-center justify-center rounded-lg hover:bg-champagne-50 text-charcoal-300 hover:text-champagne-600 transition-colors cursor-pointer">
                        <i className="ri-eye-line text-[14px]" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {selectedEvent && <EventDetailModal event={selectedEvent} onClose={() => setSelectedEvent(null)} />}
    </Layout>
  );
}
